var React = require('react');

function Open (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.93301 9.25C5.74056 9.58333 5.25944 9.58333 5.06699 9.25L0.303847 0.999999C0.111398 0.666666 0.35196 0.25 0.73686 0.25L10.2631 0.250001C10.648 0.250001 10.8886 0.666668 10.6962 1L5.93301 9.25Z","fill":"#05400A"}));
}

Open.defaultProps = {"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none"};

module.exports = Open;

Open.default = Open;
